export const envApis = {
  currencyAPI: "https://api.currencyapi.com/v3/currencies",
  currencyAPIKey: "cur_live_k16SA8PuJT1vNIXZDEQEQ48kv0UCq0r4rwFNXmg5",
};
